const callApi = async (
  endpoint,
  method = "GET",
  data = null,
  stringifyData = true,
  auth_required = true,
  setAlertMessage = () => {},
  navigate = () => {},
  customHeaders = {},
) => {
  try {
    // ---- Build Headers ----
    const headers = {
      ...(stringifyData ? { "Content-Type": "application/json" } : {}),
      ...customHeaders,
    };

    if (auth_required) {
      const token = localStorage.getItem("token");
      if (!token) {
        setAlertMessage("Authentication token missing. Please login again.");
        navigate("/");
        return { body: null, success: false, error: "Token missing" };
      }
      headers["Authorization"] = `Bearer ${token}`;
    }

    // ---- Request Options ----
    const options = { method, headers };
    if (data) options.body = stringifyData ? JSON.stringify(data) : data;

    // ---- Perform Request ----

    var url = `${process.env.REACT_APP_API}${endpoint}`;
    console.log(`API Method: ${method}`);
    console.log(`API Request: ${url}`);

    const response = await fetch(url, options);

    // ---- Handle Unauthorized ----
    if (response.status === 401) {
      setAlertMessage(
        endpoint === "/" || endpoint === "auth/login"
          ? "Bad Credentials"
          : "You are unauthorized to access this page",
      );
      localStorage.clear();
      if (endpoint !== "/" || endpoint !== "auth/login") navigate("/");
      return { body: null, success: false, error: "Unauthorized" };
    }

    // ---- Handle Other Errors ----
    if (!response.ok) {
      let errorData = {};
      try {
        errorData = await response.json();
      } catch (_) {
        // if not JSON, fallback
        errorData = { message: response.statusText };
      }
      return {
        body: errorData,
        success: false,
        error: errorData.message || "Request failed",
      };
    }

    // ---- Handle File Download ----
    const contentType = response.headers.get("Content-Type") || "";
    if (!contentType.includes("application/json")) {
      const disposition = response.headers.get("Content-Disposition");
      let filename = "download";

      if (disposition) {
        const match = disposition.match(/filename="?(.+)"?/);
        filename = match[1].replace(/["']$/, '');
      }
      
      const blob = await response.blob();
      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = filename;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      return { body: null, success: true, fileDownloaded: true };
    }

    // ---- Return JSON ----
    return {
      body:
        response.status === 204
          ? "Deleted successfully"
          : await response.json(),
      success: true,
    };
  } catch (error) {
    console.error("API Error:", error);
    setAlertMessage("Something went wrong. Please try again later.");
    return {
      body: null,
      success: false,
      error: error.message || "Network error",
    };
  }
};

export default callApi;
